exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.popover-demo-content[data-v-89667526] {\n  padding: 0.15625rem 0.3125rem;\n}\n", ""]);

// exports
